import scrollLock from 'scroll-lock';

export default class Menu {
	constructor() {
		this.hamburger = document.querySelector('[data-hamburger]');
		this.header = document.querySelector('[data-header]');
		this.menuIsOpen = false;

		this.hamburger.addEventListener('click', (e) => {
			this.toggleMenu();
		});

		window.addEventListener('scroll', (e) => {
			this.onScroll();
		});
	}

	toggleMenu() {
		if (this.menuIsOpen) {
			this.close();
		} else {
			this.open();
		}
		this.menuIsOpen = !this.menuIsOpen;
		this.onScroll();
	}

	open() {
		this.hamburger.classList.add('is-active');
		document.querySelector('body').classList.add('menu-open');
		scrollLock.disablePageScroll();
		this.trapFocus();
		this.hamburger.tabIndex = 0;
		this.hamburger.ariaLabel = 'button - sluit het menu';
	}

	close() {
		this.hamburger.classList.remove('is-active');
		document.querySelector('body').classList.remove('menu-open');
		scrollLock.enablePageScroll();
		this.removeTrapFocus();
		this.hamburger.tabIndex = 1;
		this.hamburger.ariaLabel = 'button - open het menu';
	}

	onScroll() {
		if (window.scrollY <= 0 || this.menuIsOpen) {
			document.querySelector('body').classList.remove('header-scrolling');
		} else {
			document.querySelector('body').classList.add('header-scrolling');
		}
	}

	trapFocus() {
		const focusableEls = this.header.querySelectorAll(
			'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
		);
		this.firstFocusableEl = focusableEls[0];
		this.lastFocusableEl = focusableEls[focusableEls.length - 1];

		this.tabfocussed = (event) => this.tabFocus(event);
		this.header.addEventListener('keydown', this.tabfocussed);
	}

	tabFocus(e) {
		const KEYCODE_TAB = 9;
		const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			if (document.activeElement === this.firstFocusableEl) {
				this.lastFocusableEl.focus();
				e.preventDefault();
			}
		} else {
			if (document.activeElement === this.lastFocusableEl) {
				this.firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	}

	removeTrapFocus(element) {
		this.header.removeEventListener('keydown', this.tabfocussed);
	}
}
